/**
 * DetailRow — Tier 0 slice-local primitive (SCRUM-167 epic).
 *
 * Single-row label/value pair used in Property detail Identity card,
 * Unit detail Channels card, and the Create wizard Confirm step.
 * Per `~/Desktop/design_handoff_properties/source/properties.jsx`
 * line 101 — a flex row with a 140px uppercase label column and a
 * flex-1 value column, separated by a subtle bottom border.
 *
 * The `mono` prop renders the value in mono font for cross-reference
 * ids (aliases, license numbers, OTA listing ids).
 */

import * as React from 'react';

export interface DetailRowProps {
  readonly label: string;
  readonly value: React.ReactNode;
  /** Render the value in mono font (for ids, license numbers, etc). */
  readonly mono?: boolean;
}

export function DetailRow({
  label,
  value,
  mono = false,
}: DetailRowProps): React.ReactElement {
  return (
    <div
      className="flex items-center py-2.5"
      style={{ borderBottom: '1px solid var(--border-subtle)' }}
    >
      <div
        className="text-xs font-bold uppercase w-32"
        style={{
          color: 'var(--fg-tertiary)',
          letterSpacing: '0.05em',
        }}
      >
        {label}
      </div>
      <div
        className="flex-1 text-sm"
        style={{
          color: 'var(--fg-primary)',
          fontFamily: mono ? 'var(--font-mono)' : 'inherit',
        }}
      >
        {value}
      </div>
    </div>
  );
}
